
import GoogleLogin from "@/components/login/GoogleLogin.vue";
import LoginForm from "@/components/login/LoginForm.vue";

export default {
  name: "LoginView",
  components: { LoginForm, GoogleLogin },
};
